import { EContactCustomId } from "@rentiohq/shared-frontend/dist/redux/contact/contact.types";
import {
  EContactInitialType,
  IContact,
} from "@rentiohq/shared-frontend/dist/types/contact.types";
import { IAddress } from "@rentiohq/shared-frontend/dist/types/property.types";

export enum EField {
  Header = "_header",
  Header2 = "_header2",
  InitialType = "initialType",

  Company = "company",
  VATNumber = "VATNumber",

  FirstName = "firstName",
  LastName = "lastName",
  Email = "email",
  Phone = "phone",

  PrefillAddress = "PrefillAddress",
  Address = "address",

  Street = "street",
  Number = "number",
  Box = "box",
  Zip = "zip",
  Country = "country",
  City = "city",

  Language = "locale",

  DateOfBirth = "dateOfBirth",
  PlaceOfBirth = "placeOfBirth",
  CountryOfBirth = "countryOfBirth",
  Nationality = "nationality",

  IdType = "idType",
  NationalRegisterNumber = "nationalRegisterNumber",
  ForeignIdentityNumber = "foreignIdentityNumber",

  BIVNumber = "bivNumber",

  IdentityFrontDocument = "IDCardFrontside",
  IdentityBackDocument = "IDCardBackside",

  SendInvite = "sendInvite",

  CountryId = "countryId",
}

export interface IExtraData {
  isCompany: boolean;
  isBroker?: boolean;
  contact?: Omit<Partial<IContact>, "id" | "members">;
  contactId?: number;
  baseAccountId?: number;
  customContactId?: EContactCustomId;
  fields?: EField[];
  optionalFields?: EField[];
  prefilledAddress?: IAddress;
  initialType?: EContactInitialType;
  showSendInvite?: boolean;
}
